<script setup lang="ts">
import type { DrBlockEntry } from "@/composable/useObjectsCatalog";

/** Bloc prédéfini Inspexio : son dessin et son nom (désormais cherchable). */
defineProps<{
  block: DrBlockEntry;
  active: boolean;
}>();

const emit = defineEmits<{ (e: "select"): void }>();
</script>

<template>
  <button
    type="button"
    class="dr-block-cell"
    :class="{ active }"
    :aria-pressed="active"
    @click="emit('select')"
  >
    <!-- alt vide : le libellé dessous nomme déjà le bouton -->
    <img :src="block.image" alt="" class="dr-block-img" />
    <span class="dr-block-label">{{ block.label }}</span>
  </button>
</template>

<style lang="scss" scoped>
.dr-block-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 6px 4px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;

  &:hover:not(.active) {
    background-color: rgba(255, 255, 255, 0.08);
  }

  &.active {
    border-color: var(--canvas-btn-active-bg);
    background-color: var(--canvas-btn-active-bg);
    color: #1a1a1a;
  }
}

.dr-block-img {
  width: 100%;
  height: 48px;
  object-fit: contain;
}

.dr-block-label {
  max-width: 100%;
  overflow: hidden;
  font-size: 10.5px;
  line-height: 1.2;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
